<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-buttons>
          <ion-button @click="closeModal">
            <ion-icon :style="{marginRight: '2px'}" size=small :icon="arrowBack"></ion-icon>
            <ion-label>Voltar</ion-label>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-list>
        <ion-item button detail="false" @click="update">
          <ion-icon :style="{marginRight: '10px'}" size=small :icon="refresh"></ion-icon>
          <ion-label>
            <h3>Atualizar</h3>
            <p>Buscar nova versão do aplicativo</p>
          </ion-label>
        </ion-item>
        <ion-item button detail="false" @click="install">
          <ion-icon :style="{marginRight: '10px'}" size=small :icon="downloadOutline"></ion-icon>
          <ion-label>
            <h3>Instalar</h3>
            <p>Instala aplicativo no aparelho mobile</p>
          </ion-label>
        </ion-item>
        <ion-item button detail="false" @click="signOut">
          <ion-icon :style="{marginRight: '10px'}" size=small :icon="refresh"></ion-icon>
          <ion-label>
            <h3>Sair</h3>
            <p>Sair do aplicativo</p>
          </ion-label>
        </ion-item>
      </ion-list>
      <!-- <Notification :justBadge="false" /> -->
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonLabel,
  IonHeader,
  IonButtons,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  // IonTitle,
  IonContent,
  IonToolbar,
  IonPage,
  // IonCard,
  // IonCardHeader,
  // IonCardTitle,
  // IonRow,
} from "@ionic/vue";
import { defineComponent } from "@vue/runtime-core";
import { modalController } from "@ionic/vue";
// import Notification from "../Templates/Notification.vue";
import {
  notifications,
  exit,
  arrowBack,
  refresh,
  helpBuoyOutline,
  downloadOutline
} from "ionicons/icons";

import store from "../../store";
import { createNamespacedHelpers } from "vuex";
const { mapActions: authActions } = createNamespacedHelpers("auth");
const { mapActions: registersActions } = createNamespacedHelpers("registers");

export default defineComponent({
  name: "Modal",
  components: {
    IonLabel,
    IonHeader,
    IonButtons,
    IonButton,
    IonIcon,
    IonContent,
    // IonTitle,
    IonToolbar,
    IonPage,
    // IonCard,
    // IonCardHeader,
    // IonCardTitle,
    // IonRow,
    // Notification,
  },
  setup() {
    return {
      notifications,
      exit,
      arrowBack,
      refresh,
      helpBuoyOutline,
      downloadOutline
    };
  },
  computed: {
    hasDeferredPrompt() {return !!store && !!store.$deferredPrompt}
  },
  methods: {
    ...authActions(["signOut"]),
    ...registersActions(["showToast"]),
    async closeModal() {
      await modalController.dismiss();
    },
    showTickets() {
      this.closeModal();
      this.$router.push("/tabs/tickets/listar");
    },
    update() {
      navigator.serviceWorker.getRegistrations()
        .then(registrations => {
          for (const [ix, registration] of registrations.entries()) {
            console.info('[Service Worker] Updating Service Worker')
            this.showToast({ message: "Atualizando! Por favor aguarde.", color: "warning" });
            registration.update()
              .then(res => {
                setTimeout(() => {
                  // Força o refresh caso não atualize
                  console.info('[Service Worker] Reload Forçado')
                  window.location.reload(true)
                }, 1000*2);
              })
          }
        })
    },
    install() {
      if (store.$deferredPrompt) {
        store.$deferredPrompt.prompt()
        // store.$deferredPrompt.userChoice.then(choiseResult => {
        //   console.info(choiseResult.outcome)
        // })
        store.$deferredPrompt = null
      }
    }
  }
});
</script>

<style></style>
